import onCoordinatesTimelineStatus from "./on-coordinates-timeline-status";
import onIntervalTimelineStatus from "./on-interval-timeline-status";

/**
 *
 * @param {TemporaryDataProps} data
 * @param {Boolean} enter
 * @param {Number} percents
 * @param {Boolean} coords
 */
const onTimelineStatus = (data, enter, percents, coords) => {
  if (coords) {
    onCoordinatesTimelineStatus(data);
  } else {
    onIntervalTimelineStatus(data, percents, enter);
  }
};

export default onTimelineStatus;
